/** Identity providers supported by `@iot-platform/auth`. */
export enum IotAuthProvider {
  COGNITO = 'cognito'
}
